module.exports = __webpack_public_path__ + "static/media/Style1.99e6f32c.PNG";